var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-3",staticStyle:{"text-align":"center"}},[_c('page-progress',{attrs:{"is-loading":_vm.isLoading}}),_c('page-title',{attrs:{"title":_vm.pageTitle,"icon":_vm.pageIcon}}),_c('v-container',{attrs:{"fluid":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }